import { Text } from "@twilio-paste/core/text";
import React from "react";
import { SiteLink, SiteLinkProps } from "../../../shared/components";

interface GetStartedCardLinkProps {
    to: SiteLinkProps["to"];
    onClick?: () => void;
}
export const GetStartedCardLink: React.FC<GetStartedCardLinkProps> = ({ children, to }) => (
    <Text as="p" fontWeight="fontWeightSemibold">
        <SiteLink to={to}>{children}</SiteLink>
    </Text>
);
